import ColorfulPopup from './colorful-popup';
export default ColorfulPopup;
